import { render, staticRenderFns } from "./Next.vue?vue&type=template&id=1d0479b2&"
import script from "./Next.vue?vue&type=script&lang=ts&"
export * from "./Next.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports